"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProviderContent = void 0;
var useProviderContent_1 = require("./useProviderContent");
Object.defineProperty(exports, "useProviderContent", { enumerable: true, get: function () { return useProviderContent_1.useProviderContent; } });
//# sourceMappingURL=index.js.map